import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-250',
    topDivider && 'has-top-divider',
    bottomDivider && 'none'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {

    title: 'ROADMAP',
    paragraph: 'The Stages for The Aurora Project'
    
  };

  return (
    <section
      {...props}
      className={outerClasses}
      id="roadmap"
    >
      
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}> 

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-01.svg')}
                      alt="Features tile icon 01"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Networking
                    </h4>
                  <p className="m-0 text-xs">
                  • Network on Twitter spaces and various discord servers and get to know many other amazing creators, collectors and communities!  
                  
                    </p>
                    {/* <p className="m-0 text-xs">
                  //• Competitions and giveaways for early supporters
                    </p>                    */}
                   
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-02.svg')}
                      alt="Features tile icon 02"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Aurora Mint
                    </h4>
                    <p className="m-0 text-xs">
                  • 200 Aurora Gems minted on <a href="https://exchange.art/collections/The%20Aurora%20Project%20" target="_blank">Exchange.art</a>
                    </p>
                    <p className="m-0 text-xs">
                  • 40 listed on <a href="https://exchange.art/collections/The%20Aurora%20Project%20" target="_blank">Exchange.art</a>
                    </p>
                    <p className="m-0 text-xs">
                  • Small batches at Auctions
                    </p>

                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-03.svg')}
                      alt="Features tile icon 03"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Charity
                    </h4>
                    <p className="m-0 text-xs">
                  • 15% from Sales donated to charity for Ehlers-Danlos suppor
                    </p>
                    {/* <p className="m-0 text-xs">
                  • List on secondary markets!
                    </p> */}
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-04.svg')}
                      alt="Features tile icon 04"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Secondary Markets
                    </h4>
                    <p className="m-0 text-xs">
                  • Listing on secondary markets.
                    </p>
                    <p className="m-0 text-xs">
                  • Tokenomics for longterm holders revealed. 
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-05.svg')}
                      alt="Features tile icon 05"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    NFT/Physical Collection!
                    </h4>
                    <p className="m-0 text-xs">
                  • This project began many months ago merging NFTs with physical art.
                    </p>
                    <p className="m-0 text-xs">
                  • Individual pieces for auction and a full Display collectioned fractionalised 
                    </p>
                    <p className="m-0 text-xs">
                  • Holders of any Aurora Gems / ElectricEmma 1of1's rewarded with tokens.
                    </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/feature-tile-icon-06.svg')}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Not the end of the road!
                    </h4>
                    <p className="m-0 text-xs">
                  • Individual pieces auctioned. 
                    </p>
                    <p className="m-0 text-xs">
                  • Public Token sale for display collection.
                    </p>
                    <p className="m-0 text-xs">
                  • More on the way...
                    </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;